import { Box } from "@mui/material";
import { DotLegalButton, DotLegalHeader, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { publicRiskObservationStyles as styles } from "../PublicRiskObservation.styles";

export interface IObservationStepProps {
    name: string;
    description: string;
    nameErrorText?: string;
    onNameChange: (name: string) => void;
    onDescriptionChange: (description: string) => void;
    onBack: () => void;
    onContinue: () => void;
}

function ObservationStep(props: IObservationStepProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <Box sx={styles.content}>
                <DotLegalHeader headerStyle="extraLarge" marginBottom={0}>
                    {translateString("reportObservationWhatHeader")}
                </DotLegalHeader>
                <DotLegalHeader headerStyle="small" fontWeight={400} marginBottom={0}>
                    {translateString("reportObservationWhatText")}
                </DotLegalHeader>
                <Box sx={styles.fieldGroup}>
                    <DotLegalTextField
                        debounce={false}
                        label={translateString("reportObservationNameLabel")}
                        placeholder={translateString("reportObservationNamePlaceholder")}
                        value={props.name}
                        onChange={props.onNameChange}
                        errorText={props.nameErrorText}
                        autoFocus
                        noMargin
                    />
                    <DotLegalTextField
                        debounce={false}
                        label={translateString("reportObservationDescriptionLabel")}
                        placeholder={translateString("reportObservationDescriptionPlaceholder")}
                        value={props.description}
                        onChange={props.onDescriptionChange}
                        multiline
                        rows={4}
                        noMargin
                    />
                </Box>
            </Box>
            <Box sx={styles.footer}>
                <DotLegalButton buttonType="secondary" size="medium" onClick={props.onBack}>
                    {translateString("previous")}
                </DotLegalButton>
                <Box sx={styles.footerPrimary}>
                    <DotLegalButton buttonType="primary" size="medium" fullWidth onClick={props.onContinue}>
                        {translateString("continue")}
                    </DotLegalButton>
                </Box>
            </Box>
        </>
    );
}

export default ObservationStep;
